import { render } from "./SELECT_AND_NAVIGATE.vue?vue&type=template&id=ebd256d0"
import script from "./SELECT_AND_NAVIGATE.vue?vue&type=script&lang=js"
export * from "./SELECT_AND_NAVIGATE.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-kiosk\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__